import { logOut } from '../common/auth/Auth';
import { getBaseUrl } from '../common/getBaseUrl';

declare const chrome: any;

const { REACT_APP_TIMELIVE_API, NODE_ENV, REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env;

const fetchTimeliveAPI = async (
    url: string, 
    method: string, 
    body?: any, 
    includeHeader: boolean = true, 
    accessToken: string = '', 
    isAttachment: boolean = false
) => {
    let finalBody = null;

    if (body !== '' && body !== undefined && body !== null) {
        finalBody = isAttachment ? body : JSON.stringify(body);
    }

    const isExtension =
        typeof chrome !== 'undefined' &&
        !!chrome.runtime &&
        !!chrome.runtime.id;

    let base_url = '';

    if (isExtension) {
        const dynamicBaseUrl = await getBaseUrl();
        const cleanDomain = dynamicBaseUrl ? dynamicBaseUrl.trim().replace(/\/+$/, '') : '';

        if (
            cleanDomain.includes('localhost') ||
            cleanDomain.includes('127.0.0.1') ||
            cleanDomain.includes('192.168.')
        ) {
            base_url = `${cleanDomain}/`;
        } else if (cleanDomain) {
            base_url = cleanDomain.endsWith('/timelive-api')
                ? `${cleanDomain}/`
                : `${cleanDomain}/timelive-api/`;
        } else {
            base_url = REACT_APP_TIMELIVE_API || '';
        }
    } else if (NODE_ENV === 'development') {
        base_url = REACT_APP_TIMELIVE_API || '';
    } else {
        base_url = `${window.origin}/timelive-api/`;
    }

    if (base_url && !base_url.endsWith('/')) {
        base_url += '/';
    }

    const cleanUrl = url.startsWith('/') ? url.slice(1) : url;
    const finalUrl = `${base_url}${cleanUrl}`;

    let token = localStorage.getItem('accessToken');
    if (isExtension && typeof chrome !== 'undefined' && chrome.storage?.local) {
        try {
            const stored = await chrome.storage.local.get(['accessToken']);
            token = stored?.accessToken || '';
        } catch (storageError) {
            console.error('Extension - Unable to get token from chrome.storage:', storageError);
        }
    }
//     let token = '';

//     if (isExtension && typeof chrome !== 'undefined' && chrome.storage?.local) {
//         try {
//             const stored = await chrome.storage.local.get(['accessToken']);
//             token = stored?.accessToken || '';
//         } catch (storageError) {
//             console.error('Extension - Unable to get token from chrome.storage:', storageError);
//         }
//     }

//   if (!token) {
//         token = localStorage.getItem('accessToken') || '';
//     }

//   if (!token && accessToken) {
//         token = accessToken;
//     }

    // let headersText: Record<string, string> = {};
    let headersText = {};
    if (includeHeader) {
        headersText = isAttachment
            ? {
                "Accept-Language": navigator.language?.toLowerCase().startsWith("th") ? "en-UK" : navigator.language,
                AccessToken: token
            }
            : {
                'Content-Type': 'application/json',
                "Accept-Language": navigator.language?.toLowerCase().startsWith("th") ? "en-UK" : navigator.language,
                AccessToken: token
            };
    }

    let init: RequestInit = {
        method,
        headers: headersText,
        body: finalBody,
        mode: 'cors'
    };

    if (url.includes('react.svc')) {
        init = {
            method,
            mode: 'cors',
            headers: headersText,
            body: finalBody
        };
    }

    if (NODE_ENV === 'production') {
        init = {
            method,
            headers: headersText,
            body: finalBody
        };
    }

    try {
        const response = await fetch(finalUrl, init);

        if (response.status === 401) {
            if (isExtension) {
                if (typeof chrome !== 'undefined' && chrome.storage?.local) {
                    await chrome.storage.local.clear();
                }
            }
            localStorage.clear();
            sessionStorage.clear();
            if (!isExtension) {
                window.location.href = `${window.origin}`;
            }

            throw new Error(`Unauthorized - ${response.status}`);
        }

        return response;
    } catch (error) {
        console.error('fetchTimeliveAPI - Error:', error);
        throw error;
    }
};

export default fetchTimeliveAPI;

export const toBase64 = (str: string) => {
    return window.btoa(unescape(encodeURIComponent(str)));
};